import React from "react";
import { IconType } from "react-icons";
import { SlHome } from "react-icons/sl";
import { RxSpeakerLoud } from "react-icons/rx";
import {
  BiMoviePlay,
  BiNews,
  BiLogOutCircle,
  BiCategoryAlt,
} from "react-icons/bi";
import {
  MdArticle,
  MdDashboard,
  MdLiveTv,
  MdOutlinePoll,
  MdWebStories,
  MdOutlineQuiz,
  MdAmpStories,
  MdOutlineCampaign,
  MdOutlineSubscriptions,
  MdEmail,
  MdOutlinePublic,
} from "react-icons/md";
import {
  IoFootballOutline,
  IoSchoolOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { FaUsers } from "react-icons/fa";
import { AiOutlinePaperClip } from "react-icons/ai";
import { RiLogoutCircleRLine, RiAdvertisementLine } from "react-icons/ri";
import { FiUsers } from "react-icons/fi";
import { BsBook, BsFullscreen } from "react-icons/bs";
import {
  FaRegImages,
  FaVoteYea,
  FaFileSignature,
  FaTabletAlt,
} from "react-icons/fa";
import { CgProfile, CgScreenWide, CgUnavailable } from "react-icons/cg";
import { TbLayersSubtract, TbHistoryToggle } from "react-icons/tb";
import { FaUserTie } from "react-icons/fa";


function DynamicIcon(props: any) {
  type IconName =
    | "IoFootballOutline"
    | "BiMoviePlay"
    | "CgUnavailable"
    | "SlHome"
    | "RxSpeakerLoud"
    | "MdLiveTv"
    | "RiLogoutCircleRLine"
    | "FiUsers"
    | "BiCategoryAlt"
    | "BsBook"
    | "MdOutlinePoll"
    | "BiNews"
    | "AiOutlinePaperClip"
    | "RiAdvertisementLine"
    | "RiLogoutCircleRLine"
    | "MdAmpStories"
    | "IoSchoolOutline"
    | "MdOutlineQuiz"
    | "FaRegImages"
    | "BiLogOutCircle"
    | "CgProfile"
    | "MdArticle"
    | "MdWebStories"
    | "TbLayersSubtract"
    | "CgScreenWide"
    | "FaTabletAlt"
    | "IoSettingsOutline"
    | "FaFileSignature"
    | "BsFullscreen"
    | "FaVoteYea"
    | "TbHistoryToggle"
    | "MdDashboard"
    | "MdOutlineCampaign"
    | "MdOutlineSubscriptions"
    | "MdEmail"
    | "MdOutlinePublic"
    | "FaUsers"
    | "FaUserTie";

  interface IconProps {
    iconName: IconName;
    size?: number;
    color?: string;
  }

  function Icon({ iconName, size = 26, color = "red" }: IconProps) {
    const icons: Record<IconName, IconType> = {
      IoFootballOutline: IoFootballOutline,
      CgUnavailable: CgUnavailable,
      SlHome: SlHome,
      BsBook: BsBook,
      MdOutlinePoll: MdOutlinePoll,
      RxSpeakerLoud: RxSpeakerLoud,
      BiMoviePlay: BiMoviePlay,
      MdLiveTv: MdLiveTv,
      RiLogoutCircleRLine: RiLogoutCircleRLine,
      FiUsers: FiUsers,
      BiCategoryAlt: BiCategoryAlt,
      BiNews: BiNews,
      RiAdvertisementLine: RiAdvertisementLine,
      AiOutlinePaperClip: AiOutlinePaperClip,
      MdAmpStories: MdAmpStories,
      IoSchoolOutline: IoSchoolOutline,
      FaRegImages: FaRegImages,
      CgProfile: CgProfile,
      BiLogOutCircle: BiLogOutCircle,
      MdArticle: MdArticle,
      TbLayersSubtract: TbLayersSubtract,
      MdWebStories: MdWebStories,
      MdOutlineQuiz: MdOutlineQuiz,
      CgScreenWide: CgScreenWide,
      FaTabletAlt: FaTabletAlt,
      IoSettingsOutline: IoSettingsOutline,
      FaFileSignature: FaFileSignature,
      BsFullscreen: BsFullscreen,
      FaVoteYea: FaVoteYea,
      TbHistoryToggle: TbHistoryToggle,
      MdDashboard: MdDashboard,
      MdOutlineCampaign: MdOutlineCampaign,
      MdOutlineSubscriptions: MdOutlineSubscriptions,
      MdEmail: MdEmail,
      MdOutlinePublic: MdOutlinePublic,
      FaUsers: FaUsers,
      FaUserTie: FaUserTie,
    };

    if (!icons.hasOwnProperty(iconName)) {
      console.warn(
        `Icon '${iconName}' not found. Rendering default icon instead.`
      );
      iconName = "CgUnavailable";
    }

    const IconComponent = icons[iconName];

    return <IconComponent size={size} color={props.color} />;
  }

  return <Icon iconName={props.name} size={props.size} />;
}
export default DynamicIcon;
